import {useContext,useLayoutEffect,useRef,useState,type ReactNode,type MouseEvent,type CSSProperties} from 'react';
import {createPortal} from 'react-dom';
import {DialogHostContext} from '@platform/ui/Dialog';

// The current game view owns one interactive footer. Desktop spans the room;
// smaller layouts keep their surface width. Panels only change the visual layer.
export function RoomFooter({children,feedback}:{children:ReactNode;feedback?:ReactNode}){
 const layer=useContext(DialogHostContext)!,slot=useRef<HTMLDivElement>(null),dock=useRef<HTMLDivElement>(null);
 const [box,setBox]=useState({left:0,width:0,height:0,insetLeft:'0px',insetRight:'0px'});
 const [insidePanel,setInsidePanel]=useState(false);
 useLayoutEffect(()=>{
  const origin=slot.current,footer=dock.current,shell=layer.host?.closest<HTMLElement>('.tombala-room');
  const room=shell?.querySelector<HTMLElement>('.game-room');
  if(!origin||!footer||!shell||!room)return;
  setInsidePanel(!!origin.closest('dialog'));
  let frame=0;
  const measure=()=>{
   frame=0;
   const style=getComputedStyle(origin),source=style.getPropertyValue('--room-footer-full-width').trim()==='1'?room:origin;
   const rect=source.getBoundingClientRect(),height=footer.getBoundingClientRect().height;
   const next={left:rect.left,width:rect.width,height,insetLeft:style.getPropertyValue('--room-footer-inset-left'),insetRight:style.getPropertyValue('--room-footer-inset-right')};
   setBox(previous=>Object.keys(next).every(key=>next[key as keyof typeof next]===previous[key as keyof typeof previous])?previous:next);
   if(shell.style.getPropertyValue('--room-bottom-cta-height')!==height+'px')shell.style.setProperty('--room-bottom-cta-height',height+'px');
  };
  const queue=()=>{if(!frame)frame=requestAnimationFrame(measure);};
  measure();const resize=new ResizeObserver(queue);resize.observe(origin);resize.observe(footer);resize.observe(room);
  window.addEventListener('resize',queue);window.addEventListener('scroll',queue,{passive:true,capture:true});
  return()=>{cancelAnimationFrame(frame);resize.disconnect();window.removeEventListener('resize',queue);window.removeEventListener('scroll',queue,true);shell.style.removeProperty('--room-bottom-cta-height');};
 },[layer.host]);
 const activate=(event:MouseEvent)=>{
  if(!(event.target instanceof Element)||!event.target.closest('.bottom-cta-actions button:not(:disabled)'))return;
  const owner=slot.current?.closest('dialog'),index=layer.layers.findIndex(item=>item.element===owner);
  // CTA navigation returns to its game surface. Preserve the purchase panel
  // that owns a basket, and close only the informational/quick panels above it.
  for(const item of layer.layers.slice(index+1).reverse())item.close();
 };
 return <><div ref={slot} className="room-footer-slot" style={{height:insidePanel?0:box.height}} aria-hidden="true"/>{layer.host&&createPortal(
  <div ref={dock} className="room-footer-dock" style={{left:box.left,width:box.width,visibility:box.width?'visible':'hidden',zIndex:62+layer.layers.length*2,'--room-footer-inset-left':box.insetLeft,'--room-footer-inset-right':box.insetRight} as CSSProperties} onClickCapture={activate}>{feedback&&<div className="room-footer-feedback" data-ui="purchase-feedback">{feedback}</div>}{children}</div>,layer.host
 )}</>;
}
